import React, { FC } from 'react';
import SectionTitle from '@src/components/SectionTitle';
import { TextField } from '@src/components/TextField';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { trackEvent } from '@src/metrics';
import { PositionTitleProps } from './props';
import './styles.scss';

export const PositionTitle: FC<PositionTitleProps> = ({ initTitle, openingId, setTitle }) => {
  const onJobTitleChange = (newJobTitle: string) => {
    setTitle(newJobTitle);
  };

  return (
    <div className="position-title">
      <SectionTitle subtitle="Title or headline for who you are looking for." title="Job opening title" />

      <div className="position-title-input-wrapper">
        <TextField
          defaultValue={initTitle}
          onBlur={e =>
            trackEvent({
              context: MetricContext.CREATE_OPENING,
              interaction: MetricAction.SET_POSITION_TITLE,
              payload: {
                'Opening Id': openingId,
                'Position Title': e.target.value,
              },
            })
          }
          onChange={onJobTitleChange}
          wrapperClassName="position-title__input"
        />
      </div>
    </div>
  );
};
